export default {
  cartItems({ cart: { items = [] } }) {
    return items;
  },
  cartItemsCount({ cart: { count = 0 } }) {
    return count;
  },
  cartMenuId({ cart: { menu_id: id } }) {
    return id;
  },
  cartShareKey({ cart: { share_key: key } }) {
    return key;
  },
  cartTotal({ cart: { total } }) {
    return total;
  },
  isCartEmpty({ cart: { items = [] } }) {
    return !items.length;
  },
};
